import { Factory } from "./../core/factory";

import { BaseMark } from "./base/base-mark";

import { createPath, registerPath, registerShadowRoot } from "../vrender-bridge";

export class PathMark extends BaseMark {
    constructor() {
        super(...arguments), this.type = PathMark.type;
    }
    _getDefaultStyle() {
        return Object.assign(Object.assign({}, super._getDefaultStyle()), {
            lineWidth: 0,
            path: ""
        });
    }
}

PathMark.type = "path";

export const registerPathMark = () => {
    Factory.registerMark(PathMark.type, PathMark), registerShadowRoot(), registerPath(), 
    Factory.registerGraphicComponent("path", createPath);
};
//# sourceMappingURL=path.js.map
